import { videoIdentificationApi } from 'api';
import { ViDetails } from 'pco-product-service-internal-consumer';

export const getVideoIdentificationDetails = async (serviceAgreementId: string): Promise<ViDetails> => {
  return await videoIdentificationApi.getVideoIdentDetails({ serviceAgreementUid: serviceAgreementId });
};
